/**
 * @generated SignedSource<<9beeb3d56d1a6db1b1b416f3c7c7db77>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "activeOnly"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "purpose"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "accountid",
        "variableName": "accountId"
      },
      {
        "kind": "Variable",
        "name": "activeonly",
        "variableName": "activeOnly"
      },
      {
        "kind": "Variable",
        "name": "purpose",
        "variableName": "purpose"
      }
    ],
    "concreteType": "PaymentSourceWithAggregate7SConnection",
    "kind": "LinkedField",
    "name": "paymentsourceswithaggregate7",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PaymentSourceWithAggregate7",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "psId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "psType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "psStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "paidMtd",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "paidLastMonth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "paidYtd",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "paidLifetime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ccBrand",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ccLast4",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ccExpy",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fiName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "achAccountNum",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "extSource",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "extPsId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "paypalEmail",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maxPsOrder",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maxPsOrderIn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "psStatusOther",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "declineCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastDeclineReason",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastDeclineChargeAmount",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CustomerChargeLimitQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CustomerChargeLimitQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e54cfe533da5b5b05ac61977eba8d932",
    "id": null,
    "metadata": {},
    "name": "CustomerChargeLimitQuery",
    "operationKind": "query",
    "text": "query CustomerChargeLimitQuery(\n  $accountId: UUID!\n  $activeOnly: Int\n  $purpose: Int\n) {\n  paymentsourceswithaggregate7(accountid: $accountId, activeonly: $activeOnly, purpose: $purpose) {\n    totalCount\n    nodes {\n      psId\n      psType\n      psStatus\n      paidMtd\n      paidLastMonth\n      paidYtd\n      paidLifetime\n      ccBrand\n      ccLast4\n      ccExpy\n      fiName\n      achAccountNum\n      firstName\n      lastName\n      extSource\n      extPsId\n      paypalEmail\n      maxPsOrder\n      maxPsOrderIn\n      psStatusOther\n      declineCount\n      lastDeclineReason\n      lastDeclineChargeAmount\n    }\n  }\n}\n"
  }
};
})();

node.hash = "5d689539ff4814581ad13cf04cf76e4c";

module.exports = node;
